var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailCheckLine = function SvgMailCheckLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5 13.8h-1.8V7.715l-7.135 6.39L5.3 7.695V18.3h9v1.8H4.4a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9zM5.76 5.7l6.795 5.996L19.252 5.7zM18.8 21l-3.182-3.182 1.273-1.273 1.909 1.91 3.182-3.182 1.273 1.272z"
  })));
};
export default SvgMailCheckLine;